export class NavigationEvent {
  itemId: string | null = null;
  subitemId: string | null = null;
  subSubitemId: string | null = null;
  origin: NavigationEventOrigin | null = null;

  constructor(
    itemId: string | null,
    subitemId: string | null,
    subSubitemId: string | null,
    origin: NavigationEventOrigin
  ) {
    this.itemId = itemId;
    this.subitemId = subitemId;
    this.subSubitemId = subSubitemId;
    this.origin = origin;
  }

  getFullItemIdPath(): string {
    let parts = [this.itemId, this.subitemId, this.subSubitemId];
    parts = parts.filter(x => x !== undefined && x !== null);

    return parts.join('/');
  }
}

export enum NavigationEventOrigin {
  Sidebar,
  MainNav,
  MainNavAvatar,
  Breadcrumb,
}
